export default __webpack_public_path__ + "static/media/PUMA SAFARI HERO MASTER 16x9_15_220921.64c301a0.mp4";